import React from "react";
import { MySchedule } from "../../templates/MySchedule";

const MySchedulePage = () => {
  const apiKey: any = process.env.REACT_APP_CALENDAR_API_KEY;
  const calendarId: any = process.env.REACT_APP_CALENDAR_ID;

  let calendars = [{ calendarId }];

  return <MySchedule apiKey={apiKey} calendars={calendars} />;
};

export default MySchedulePage;
